<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
        v-if="consents !== undefined && consents.length !== 0">
        <div
            class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <div class="d-sm-flex align-items-center">
                <h5 class="fw-medium text-black-emphasis mb-0">{{ $t('feature.$consents.role_enabled_consents', {role: $t(`feature.roles.$type.${role.type}`)}) }}</h5>
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <SpinnerLoading v-if="consents.every((consent) => consent.linked === undefined)" class="mt-50" />
            <div class="table-responsive" v-else>
                <table class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                {{ $t('form.title.label') }}
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                {{ $t('form.description.label') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody> <!-- class="linked" -->
                        <tr v-for="consent in consents" :key="consent.id">
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ consent.title }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                        {{ consent.description }}
                                    </div>
                                    <div>
                                        <SpinnerLoading class="h-auto" style="width: 30px;"
                                            v-if="loading_consent_id === consent.id" :small="true" />
                                        <div class="form-check form-group form-switch m-0" v-else>
                                            <input class="form-check-input shadow-none" type="checkbox" role="switch"
                                                v-model="consent.linked" :id="`${consent.id}-link`"
                                                @change="($event) => updateConsent(consent, $event)">
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <AlertModal :id="`alertModal_${role.id}`" :title="$t('feature.roles.remind_policies.title')"
        :message="$t('feature.roles.remind_policies.message', {type: $t(`feature.roles.$type.${role.type}`)})" @close="alertModal?.hide()" />

</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import { Consent } from "@/utils/models/consent.model";
import API from "@/services/api/api.service";
import { RoleInfo } from "@/utils/models/user.model";
import { AxiosResponse } from "axios";
import AlertModal from "@/components/Widgets/AlertModal.vue";
import { Modal } from "bootstrap";

interface ConsentWithRoleLink extends Consent {
    linked?: boolean
};

type RoleOperation = (params: { consent_id: string | number, role_id: string | number }) => Promise<AxiosResponse<any, any>>;

export default defineComponent({
    name: 'RoleConsents',
    components: {
        SpinnerLoading,
        AlertModal
    },
    props: {
        role: {
            type: Object as PropType<RoleInfo>,
            required: false,
            default: () => ({}) as RoleInfo
        }
    },
    data: function () {
        return {
            // role: (this.$route.meta.role ?? {}) as RoleInfo,
            consents: [] as ConsentWithRoleLink[],
            linked_roles: [] as number[],
            loading_consent_id: undefined as number | string | undefined,
            alertModal: undefined as Modal | undefined,
            no_consents: false as boolean
        }
    },
    async mounted() {
        this.alertModal = new Modal(`#alertModal_${this.role.id}`, {});
        await this.loadConsents();
    },
    methods: {
        loadConsents: async function () {
            this.consents = [];
            await API.getConsents().then((response) => {
                this.consents = response.data?.data ?? [];
            });

            await Promise.all(this.consents.map((consent) => this.loadConsentRole(consent)));
            this.no_consents = this.consents?.every((consent) => consent.linked === false);

            if (this.no_consents) {
                this.alertModal?.show();
            }

        },
        loadConsentRole: async function (consent: ConsentWithRoleLink) {
            await API.getConsentRoles({ consent_id: consent.id! }).then((response) => {
                let roles = response.data.data as RoleInfo[];
                let linked = roles.some((role) => role.id === this.role.id);
                consent.linked = linked;

            });
        },
        updateConsent(consent: ConsentWithRoleLink, $event: Event) {
            consent.linked = !consent.linked;
            this.loading_consent_id = consent.id;
            let api: RoleOperation;
            /* DELETE CONSENT */
            if (consent.linked) {
                api = API.deleteConsentRole as RoleOperation;
            } else {
                api = API.storeConsentRole as RoleOperation;
            }
            api({ consent_id: consent.id!, role_id: this.role.id }).then((response) => {
                if (response.data.success === true) {
                    consent.linked = !consent.linked;
                }
            }).finally(() => {
                this.loading_consent_id = undefined;
            });
        }
    }
});
</script>